import { useNavigate } from "react-router-dom";
import { useCreateGroup, useModifyGroupMember } from "../../../../api/admin/group/hooks";
import GroupForm from "../../../organisms/GroupForm";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../reducer/alertSlice";

/**
 * 그룹 생성 화면 - 관리자
 */
const GroupCreate = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { mutate: createGroup, isLoading: creatingGroup } = useCreateGroup()
    const { mutate: modifyGroupMember, isLoading: modifyingGroupMember } = useModifyGroupMember()

    const createHandler = async ({ title, description, selectedUserList }) => {
        createGroup(
            { title, description },
            {
                onSuccess: (data) => {
                    switch (data.code) {
                        case 0:
                            console.log("@GroupCreate - createGroup Success")

                            // 그룹 생성 성공 후 그룹 참여 인원 수정까지 이어서 진행
                            modifyGroupMember(
                                { groupIdx: data.data.idx, userIdxList: selectedUserList },
                                {
                                    onSuccess: () => {
                                        console.log("@GroupCreate - modifyGroupMember Success")
                                        navigate("/admin/group/list")
                                    },
                                    onError: err => console.error("@GroupCreate - modifyGroupMember Error", err)
                                }
                            )
                            break
                        default:
                            console.log("@GroupCreate - createGroup Success But data.code != 0 => modifyGroupMember not launch")
                    }
                },
                onError: err => {
                    if (err?.response?.data?.code === -14) {
                        dispatch(showAlert({
                            msg: '이미 존재하는 그룹명 입니다.'
                        }))
                    }
                    console.error("@GroupCreate - createGroup Error", err)
                }
            }
        )
    }

    return (
        <GroupForm 
            editable={true} 
            isModify={false}
            onSubmit={createHandler}
        />
    )
}

export default GroupCreate